<article class="block-contact">
  <div class="container section-inset-y">
    <main class="row block-contact__inner">
      <div class="col-md-4 position-relative" *ngIf="block.image?.url">
        <figure class="block-contact__figure pull-s">
          <fstr-image
            class="block-contact__image"
            [imageSizes]="[200, 400, 800, 900]"
            [image]="block.image!"
            [alt]="block.image?.alt || block.title"
            [other]="'trim.threshold=90'"
          ></fstr-image>
        </figure>
      </div>

      <section class="col-md-8 text-center text-md-start">
        <div class="mb-5 mb-lg-8">
          <h1 class="mb-2" *ngIf="block.title">
            <ngx-dynamic-hooks
              [options]="{ sanitize: false, updateOnPushOnly: true }"
              [content]="block.title || '' | highlight : 'font-display fw-bold' : false : true : 'circle-01' : 'secondary'"
              splitting
              [duration]="2000"
              [startTextAnimation]="inviewPort"
              [context]="{ delayAnimation: 400, startShapeAnimation: inviewPort }"
              class="splitting splitting--letter-in"
            ></ngx-dynamic-hooks>
          </h1>
          <p class="position-relative fs-body-md text-wrap-pretty" *ngIf="block.intro">{{ block.intro }}</p>
        </div>

        <div class="block-contact__info">
          <div class="block-contact__info__item">
            <h2 class="text-primary fs-body-xs">{{ 'footer-adres-label' | fromDictionary }}</h2>
            <p class="h4 mb-0">{{ 'brilliant-orange-adres' | fromDictionary }}</p>
          </div>
          <div class="block-contact__info__item">
            <h2 class="text-primary fs-body-xs">{{ 'footer-telefoonnummer-label' | fromDictionary }}</h2>
            <a class="text-decoration-none text-dark h4" [href]="'tel:' + ('brilliant-orange-telefoonnummer' | fromDictionary)">
              {{ 'brilliant-orange-telefoonnummer' | fromDictionary }}
            </a>
          </div>
          <div class="block-contact__info__item">
            <h2 class="text-primary fs-body-xs">{{ 'footer-email-label' | fromDictionary }}</h2>
            <p>
              <a class="text-decoration-none text-dark h4" [href]="'mailto:' + ('brilliant-orange-emailadres' | fromDictionary)">
                {{ 'brilliant-orange-emailadres' | fromDictionary }}
              </a>
            </p>
          </div>
        </div>
      </section>
    </main>
  </div>
</article>
